import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  ProjectMembersListingConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: ProjectMembersListingConfiguration;
  retrieveProjectMembersListingConfiguration(
    req: Boundaries["retrieveProjectMembersListingConfiguration"]["request"],
  ): void;
}

function useRetrieveProjectMembersListingConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectMembersListingConfigurationRequestPending(
        planzone,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectMembersListingConfigurationRequestSuccess(
        planzone,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectMembersListingConfigurationRequestFailure(
        planzone,
      ),
    ),
    configuration: useSelector(() =>
      selector.getProjectMembersListingConfiguration(planzone),
    ),
    retrieveProjectMembersListingConfiguration:
      core.retrieveProjectMembersListingConfiguration,
  };
}

export { useRetrieveProjectMembersListingConfiguration };
